import { Component, EventEmitter, Output } from '@angular/core';
import {
  matchConsultants,
  requestMatchesLevels1,
} from 'src/interface/shared.interface';
import { ContextService } from 'src/services/platform/context.service';
import { PlatformService } from 'src/services/platform/platform-service.service';

@Component({
  selector: 'app-longlist-content',
  templateUrl: './longlist-content.component.html',
  styleUrls: ['./longlist-content.component.scss'],
})
export class LonglistContentComponent {
  selectedConsultant: matchConsultants = this.contextService.selectedConsultant;
  toggleRequest: boolean;
  salesRequests: requestMatchesLevels1[];
  selectedRequest?: requestMatchesLevels1;
  rawOptions: requestMatchesLevels1[];
  toggleDropdown: boolean;
  loading: boolean;
  @Output() selected = new EventEmitter<requestMatchesLevels1>();
  constructor(
    private contextService: ContextService,
    private platformService: PlatformService
  ) {
    if (this.contextService.openMatchModal === 'longlist') {
      this.selectedRequest = this.contextService.selectedRequest;
    }
  }

  search(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value.length === 0) {
      this.salesRequests = [];
    }
    if (!this.rawOptions) {
      this.rawOptions = this.salesRequests;
    }

    if (target.value.length === 0) {
      this.salesRequests = this.rawOptions;
      return;
    }
    this.salesRequests = this.rawOptions.filter((x) => {
      const findbyTitle = x.title
        .toLowerCase()
        .replace(/\s/g, '')
        .includes(target.value.toLowerCase().replace(/\s/g, ''));
      const findbyCustomerName = x.customer.name
        .toLowerCase()
        .replace(/\s/g, '')
        .includes(target.value.toLowerCase().replace(/\s/g, ''));
      if (!findbyTitle) {
        return findbyCustomerName;
      }
      return findbyTitle;
    });
  }

  selectRequest(value: requestMatchesLevels1) {
    this.selectedRequest = value;
    this.selected.emit(value);
  }
  getSearchRequests() {
    if (this.salesRequests) {
      return;
    }
    this.loading = true;
    this.platformService.getRequests().then((response) => {
      this.salesRequests = response.data;
      this.loading = false;
    });
  }
}
